import { Link } from "react-router-dom";
import { siteInfo } from "@/mocks/star";

const FOOTER_LINKS = [
  { to: "/", label: "首页" },
  { to: "/works", label: "作品分类" },
  { to: "/news", label: "资讯动态" },
  { to: "/about", label: "关于本站" },
];

export default function SiteFooter() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-primary-950 text-background-50/85 mt-20">
      <div className="px-4 md:px-8 py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <span className="w-10 h-10 rounded-lg bg-accent-500 text-accent-950 flex items-center justify-center font-heading text-lg font-semibold">
                叶
              </span>
              <span className="font-heading text-lg font-semibold text-background-50">
                {siteInfo.name}
              </span>
            </div>
            <p className="text-sm leading-relaxed max-w-md text-background-50/70">
              {siteInfo.slogan}。专注整理叶山小百合参演的电影、电视剧资料与最新动态，为影迷与影视爱好者提供清晰、全面的作品索引。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4 tracking-wider">
              站点导航
            </h4>
            <ul className="space-y-2.5">
              {FOOTER_LINKS.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-sm text-background-50/70 hover:text-accent-300 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4 tracking-wider">
              联系方式
            </h4>
            <ul className="space-y-2.5 text-sm text-background-50/70">
              <li className="flex items-center gap-2">
                <span className="w-5 h-5 flex items-center justify-center text-background-50/50">
                  <i className="ri-mail-line"></i>
                </span>
                {siteInfo.email}
              </li>
              <li className="flex items-center gap-2">
                <span className="w-5 h-5 flex items-center justify-center text-background-50/50">
                  <i className="ri-map-pin-line"></i>
                </span>
                {siteInfo.address}
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-background-50/15 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-background-50/50">
            © {currentYear} {siteInfo.name} · 影迷资料整理
          </p>
          <p className="text-xs text-background-50/50 max-w-xl">{siteInfo.note}</p>
        </div>
      </div>
    </footer>
  );
}